// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","card":"Card_card__0jSZK"};